import request from '../../../../../services/axios';

export interface ICreditPayAvailableAmounts {
  credit_amount: number;
  bnpl_amount: number;
}

export const getCreditPayAvailableAmounts = async () => {
  const {data}: {data: ICreditPayAvailableAmounts} = await request.get(
    `/api/v2/payment/credit-amounts`,
  );

  return data;
};
